import { PERIOD_TIME_UNIT_ENUM } from '../../../../../../../enums/PeriodTimeUnitEnum';
import {EmailFrequency} from '../../../../../../../enums/EmailFrecuency';
import {calculatePeriodRange, calculateWindows} from "../../../Submission/PeriodReview/Model/Model";
import {getDaysBetween} from "../../../../../../../Apis/functions";

export const EMPTY_DEFAULT_DATE = '[MM DD YYYY]';

export const EMPTY_DEFAULT_TIME = '[HH:MM:SS]';

export const EMPTY_DEFAULT_DATE_TIME = '[MM DD YYYY HH:MM:SS]';

export const SHIFT_MODEL_DATA = {
    id: '',
    departmentId: '',
    endShiftAt: '',
    range: '',
    startShiftAt: '',
    setData(item) {
        return {
            ...this,
            ...item
        }
    }
}

const getReviewFrequency = (item) => {
    if (item.daily) return EmailFrequency.DAILY.value;
    if (item.weekly) return EmailFrequency.WEEKLY.value;
    if (item.monthly) return EmailFrequency.MONTHLY.value;
    if (item.biweekly) return EmailFrequency.BIWEEKLY.value;
    return EmailFrequency.DAILY.value;
};

export const EMAIL_VALUE_VALIDATE = {
    start: {
        min: 1,
        max: 15
    },
    end: {
        min: 16,
        max: 31
    }
}

export const EMAIL_MODEL_DATA = {
    id:null,
    reviewFrequency: '',
    scheduleTime:'',
    daysAfterSendEmail: '', //daily
    dayOfWeek: '', // weekly
    dayOfMonth: '', // monthly
    startDate: '', // Biweekly
    endDate: '', // Biweekly
    timeZone: '',
    email: '',
    imapHost: '',
    port: '',
    setData(item) {
        const frequency = getReviewFrequency(item);
        const sendDay = String(item?.sendDay ?? '');
        return {
            ...this,
            id: item.id,
            scheduleTime: item?.time,
            reviewFrequency: frequency,

            daysAfterSendEmail: item?.daily ? sendDay : '',
            dayOfWeek: item?.weekly ? sendDay : '',
            dayOfMonth: item?.monthly ? sendDay : '',

            startDate: item?.biweekly ? String(item.firstDay) : '',
            endDate: item?.biweekly ? String(item.secondDay) : '',
            timeZone: item.userTimeZone,
            email: item.email,
            imapHost: item.imapHost,
            port: item.port,
        };
    },
    toRegister() {

        const isDaily = this.reviewFrequency === EmailFrequency.DAILY.value;
        const isWeekly = this.reviewFrequency === EmailFrequency.WEEKLY.value;
        const isBiweekly = this.reviewFrequency === EmailFrequency.BIWEEKLY.value;
        const isMonthly = this.reviewFrequency === EmailFrequency.MONTHLY.value;

        const toNum = (v) => (v === "" || v == null ? 0 : Number(v));

        const sendDay = isDaily
            ? toNum(this.daysAfterSendEmail)
            : isWeekly
                ? toNum(this.dayOfWeek)
                : isMonthly
                    ? toNum(this.dayOfMonth)
                    : 0;
        return {
            id: this.id,
            time: this.scheduleTime,

            daily: isDaily,
            weekly: isWeekly,
            biweekly: isBiweekly,
            monthly: isMonthly,

            firstDay: isBiweekly ? toNum(this.startDate) : 0,
            secondDay: isBiweekly ? toNum(this.endDate) : 0,

            sendDay: sendDay,

            timeZone: this.timeZone,
            email: this.email,
            imapHost: this.imapHost,
            port: this.port
        }
    }
}


export const ATTENDANCE_CYCLE = {
    id:null,
    checkOutCooldown:null,
    frequencyValue:null,
    frequencyTimeUnit:null,
    deferredPeriodValue:null,
    supervisorReviewPeriodFrom:null,
    supervisorReviewPeriodTo:null,
    adminApprovalPeriodFrom:null,
    adminApprovalPeriodTo:null,

    startPeriod: null,
    endPeriod: null,
    frequencyTime: null,
    supervisorReviewStartDate: null,
    supervisorReviewEndDate: null,
    adminApprovalStartDate: null,
    adminApprovalEndDate: null,

    isValidFrequencyValue: true,
    isValidSupervisorReviewPeriodFrom: true,
    isValidSupervisorReviewPeriodTo: true,
    isValidAdminApprovalPeriodFrom: true,
    isValidAdminApprovalPeriodTo: true,
    isValidCheckOutCooldown: true,
    isValidSupervisorRangeFrom: true,
    isValidSupervisorRangeTo: true,
    isValidAdminRangeFrom: true,
    isValidAdminRangeTo: true,

    periodDays: 0,
    enableAttendanceCycle: false,
    setData: function (item){
        const period = calculatePeriodRange(item);

        const periodDays = getDaysBetween(
            period.startPeriod,
            period.endPeriod
        );

        return {
            ...this,
            ...item,
            periodDays,
            enableAttendanceCycle: item.frequencyValue > 0
        }
    },
    setPeriodAndWindowsRange: function (cycleItem){
        const periodRange = calculatePeriodRange(cycleItem);
        const windows = calculateWindows(cycleItem);
        return {
            ...this,
            startPeriod: periodRange?.startPeriod || null,
            endPeriod:  periodRange?.endPeriod || null,
            supervisorReviewStartDate: windows?.supervisorReviewStartDate || null,
            supervisorReviewEndDate: windows?.supervisorReviewEndDate || null,
            adminApprovalStartDate: windows?.adminApprovalStartDate || null,
            adminApprovalEndDate: windows?.adminApprovalEndDate || null,
        }
    },
    toRegister() {
        const { setData, toRegister, ...data } = this;
        return data;
    },
    isValid () {
        return this.frequencyValue &&
            Number(this.frequencyValue) >= 1 &&
            Number(this.checkOutCooldown) >= 1 &&
            this.deferredPeriodValue !== "" && this.deferredPeriodValue !== null &&
            this.supervisorReviewPeriodFrom !== "" && this.supervisorReviewPeriodFrom !== null &&
            this.supervisorReviewPeriodTo !== "" && this.supervisorReviewPeriodTo !== null &&
            this.adminApprovalPeriodFrom !== "" && this.adminApprovalPeriodFrom !== null &&
            this.adminApprovalPeriodTo !== "" && this.adminApprovalPeriodTo !== null;
    },
    windowsValid () {
        const validate = this.setWindowsValid();
        return validate.isValidSupervisorReviewPeriodFrom &&
            validate.isValidSupervisorReviewPeriodTo &&
            validate.isValidAdminApprovalPeriodFrom &&
            validate.isValidAdminApprovalPeriodTo &&

            validate.isValidSupervisorRangeFrom &&
            validate.isValidSupervisorRangeTo &&
            validate.isValidAdminRangeFrom &&
            validate.isValidAdminRangeTo
            ;
    },
    setWindowsValid () {
        const supervisorFrom = Number(this.supervisorReviewPeriodFrom);
        const supervisorTo =  Number(this.supervisorReviewPeriodTo);
        const adminFrom = Number(this.adminApprovalPeriodFrom);
        const adminTo =  Number(this.adminApprovalPeriodTo);

        const period = calculatePeriodRange({...this, deferredPeriodValue: 0});

        const periodDays = getDaysBetween(
            period.startPeriod,
            period.endPeriod
        );

        return {
            ...this,
            isValidFrequencyValue: this.frequencyValue >= 1,
            isValidSupervisorReviewPeriodFrom: supervisorFrom >= 1,
            isValidSupervisorReviewPeriodTo: supervisorTo != null && supervisorFrom != null && supervisorFrom >= supervisorTo,
            isValidAdminApprovalPeriodFrom: adminFrom >= 1,
            isValidAdminApprovalPeriodTo: adminTo != null && adminFrom != null && adminFrom >= adminTo,

            isValidSupervisorRangeFrom: periodDays >= supervisorFrom,
            isValidSupervisorRangeTo: periodDays >= supervisorTo,
            isValidAdminRangeFrom: periodDays >= adminFrom,
            isValidAdminRangeTo: periodDays >= adminTo,
            periodDays: periodDays
        };
    },
    clear () {
        return{
            ...this,
            frequencyValue:0,
            frequencyTimeUnit:PERIOD_TIME_UNIT_ENUM.WEEKS.name,
            deferredPeriodValue:0,
            supervisorReviewPeriodFrom:0,
            supervisorReviewPeriodTo:0,
            adminApprovalPeriodFrom:0,
            adminApprovalPeriodTo:0,

            startPeriod: 0,
            endPeriod: 0,
            frequencyTime: 0,
            supervisorReviewStartDate: 0,
            supervisorReviewEndDate: 0,
            adminApprovalStartDate: 0,
            adminApprovalEndDate: 0,

            isValidFrequencyValue: true,
            isValidSupervisorReviewPeriodFrom: true,
            isValidSupervisorReviewPeriodTo: true,
            isValidAdminApprovalPeriodFrom: true,
            isValidAdminApprovalPeriodTo: true,
            isValidSupervisorRangeFrom: true,
            isValidSupervisorRangeTo: true,
            isValidAdminRangeFrom: true,
            isValidAdminRangeTo: true,
            periodDays: 0,
            enableAttendanceCycle: false
        }
    }
}

export const OVERTIME_POLICY_CONFIG = {
    id: null,
    conflictResolution: null,
    stackMethod: null,
    setData(item) {
        return {
            ...this,
            id: item?.id ?? null,
            conflictResolution: item?.conflictResolution ?? null,
            stackMethod: item?.stackMethod ?? null,
        };
    },
    toRegister() {
        const isStackable = this.conflictResolution === 'STACKABLE';
        return {
            id: this.id,
            conflictResolution: this.conflictResolution,
            // Stack method only applies when the resolution is stackable.
            stackMethod: isStackable ? this.stackMethod : null,
        };
    },
    isValid() {
        if (!this.conflictResolution) return false;
        // Stack method is required only when the resolution is stackable.
        return this.conflictResolution !== 'STACKABLE' || !!this.stackMethod;
    }
}

export const PERIOD_TIME_UNIT_CYCLE = [
    {...PERIOD_TIME_UNIT_ENUM.WEEKS},
    {...PERIOD_TIME_UNIT_ENUM.MONTHS},
    {...PERIOD_TIME_UNIT_ENUM.YEARS}
]
